import { memo } from 'react';
import { ArchiveLegacy as Archive } from '@trinity/chat-components/components/icons/Archive.Legacy';
import { Check } from '@trinity/chat-components/components/icons/Check';
import { Trash } from '@trinity/chat-components/components/icons/Trash';
import { XCircle } from '@trinity/chat-components/components/icons/XCircle';
import { ConditionalTooltip } from '@trinity/chat-components/components/Widgets/Charts/Accordion/Tooltip';
import { cx } from '@trinity/chat-components/utils';
import { PlusCircle } from './PlusCircle';
import styles from './style/FormButtons.module.css';

export type FormButtonsProps = {
  archivable?: boolean;
  className?: string;
  creatable?: boolean;
  deletable?: boolean;
  disabled?: boolean;
  disabledTooltip?: string;
  onArchive?: () => unknown;
  onCancel: () => unknown;
  onDelete?: () => unknown;
  onSubmit?: () => unknown;
  onCreate?: () => unknown;
  size?: number;
};

type Props = FormButtonsProps;

const FormButtons = memo((props: Props) => (
  <div className={cx(styles.root, props.className)}>
    {props.creatable && <PlusCircle size={props.size} onClick={props.onCreate} />}
    {!(props.disabled && !props.disabledTooltip) && (
      <ConditionalTooltip enabled={!!props.disabledTooltip} title={props.disabledTooltip} placement="top">
        <span>
          <Check size={props.size} disabled={props.disabled} onClick={props.onSubmit} />
        </span>
      </ConditionalTooltip>
    )}
    {props.onCancel && <XCircle size={props.size} onClick={props.onCancel} />}
    {props.archivable && <Archive size={props.size} onClick={props.onArchive} />}
    {props.deletable && <Trash size={props.size} onClick={props.onDelete} />}
  </div>
));

export { FormButtons };
export default FormButtons;
